export const formatDate = (timestamp: number) =>
  new Date(timestamp * 1000).toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
  });
